import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=4f0095b6&"
import script from "./Base.vue?vue&type=script&lang=ts&"
export * from "./Base.vue?vue&type=script&lang=ts&"
import style0 from "./Base.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports